import React from 'react';
import qrCodeImage from '../assets/QRCode.jpg';

const QRModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className='qr-modal-overlay' onClick={onClose}>
      <div className='qr-modal' onClick={(e) => e.stopPropagation()}>
        <div className='qr-modal-close' onClick={onClose}>✕</div>
        <div className='qr-modal-content'>
          <h3 className='qr-modal-title'>Scan to Pay</h3>
          <img src={qrCodeImage} alt='Scan QR Code' className='qr-modal-image' />
          <p className='qr-modal-text'>Scan this QR code with your UPI app to make payment</p>
        </div>
      </div>
    </div>
  );
};

export default QRModal;
